import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggedOutGuard } from './Logged-out.guard';
import { LoggedInGuard } from './logged-in.guard';
import { APP_ENVIRONMENT } from '../../utilities/services/environment.injection-token';
import { environment } from '../../environments/environment';
import { L10nTranslationModule } from 'angular-l10n';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import {RouterModule} from '@angular/router';
import { UtilsService } from './utils.service';
import { MenuComponent } from './menu/menu.component';
import { MainLayoutComponent } from './_layout/main-layout/main-layout.component';
import { FrontLayoutComponent } from './_layout/front-layout/front-layout.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DialogMessageComponent } from './dialog/dialog-message/dialog-message.component';
import { DialogService } from './dialog/dialog.service';
import {MatDialogModule} from '@angular/material/dialog';
import { PrintLayoutComponent } from './_layout/print-layout/print-layout.component';
import { DialogYesNoComponent } from './dialog/dialog-yes-no/dialog-yes-no.component';
import { UppercaseDirective } from 'src/utilities/directives/uppercase.directive';
import { NoAutocompleteDirective } from 'src/utilities/directives/autocomplete.directive';
import { NotSameEmailComponent } from '../notSameEmail/notSameEmail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogConfirmSaveComponent } from './dialog/dialog-confirm-save/dialog-confirm-save.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    MainLayoutComponent,
    FrontLayoutComponent,
    SpinnerComponent,
    DialogMessageComponent,
    DialogYesNoComponent,
    PrintLayoutComponent,
    UppercaseDirective,
    NoAutocompleteDirective,
    DialogConfirmSaveComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    SpinnerComponent,
    UppercaseDirective,
    NoAutocompleteDirective,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    L10nTranslationModule,
    MatDialogModule,
    NgSelectModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LoggedInGuard,
        LoggedOutGuard,
        [{ provide: APP_ENVIRONMENT, useValue: environment }],
        UtilsService,
        DialogService
      ]
    };
  }
 }
